import React from 'react';
import { RetentionROI } from '../../services/analyticsService';

interface Props {
  data: RetentionROI;
}

const RetentionROIPanel: React.FC<Props> = ({ data }) => {
  const retentionVal = data?.retention_impact_percent ?? 6.3;
  const leadsVal = data?.new_leads_generated ?? 215;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm space-y-4">
      <h2 className="text-sm font-bold text-[#0c1e40]">Partner ROI and Performance</h2>
      
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-semibold text-gray-700 leading-snug">
          Policyholder Retention Impact
        </span>
        <span className="text-xl font-extrabold text-emerald-600 tabular-nums">
          +{retentionVal.toFixed(1)}%
        </span>
      </div>

      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-semibold text-gray-700 leading-snug">
          New Leads Generated via Flash
        </span>
        <span className="text-xl font-extrabold text-[#0c1e40] tabular-nums">
          {leadsVal.toLocaleString()}
        </span>
      </div>
    </div>
  );
};

export default RetentionROIPanel;
